import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import { CancelButton } from "../common/Button";
import {
  Row,
  Col,
  Form,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../utils/context";
import JoditEditor from "jodit-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getallPackageDetailType } from "../../utils/apis/master/Master";

library.add(fas);

// ── Moved outside to prevent re-creation on every render ─────────────────────
const emptyDescription = () => ({ content: "", images: [] });

const emptyDay = () => ({
  detail_type_id: null,
  descriptions: [emptyDescription()],
});

// ── DayDescriptions moved outside EditOffCanvance ─────────────────────────────
function DayDescriptions({ dayIndex, control, setValue, trigger, errors, IMG_URL }) {
  const {
    fields: descFields,
    append: appendDesc,
    remove: removeDesc,
  } = useFieldArray({
    control,
    name: `packages_detail.${dayIndex}.descriptions`,
  });

  const descFileRefs = useRef([]);

  const handleDescImageAdd = (descIndex, e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const currentImages =
      control._formValues.packages_detail?.[dayIndex]
        ?.descriptions?.[descIndex]?.images ?? [];

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setValue(
      `packages_detail.${dayIndex}.descriptions.${descIndex}.images`,
      [...currentImages, ...newImages],
      { shouldDirty: true }
    );
    trigger(`packages_detail.${dayIndex}.descriptions.${descIndex}.images`);
    e.target.value = "";
  };

  const handleDescImageRemove = (descIndex, imgIndex) => {
    const currentImages =
      control._formValues.packages_detail?.[dayIndex]
        ?.descriptions?.[descIndex]?.images ?? [];

    const updated = currentImages.filter((_, i) => i !== imgIndex);
    setValue(
      `packages_detail.${dayIndex}.descriptions.${descIndex}.images`,
      updated,
      { shouldDirty: true }
    );
    trigger(`packages_detail.${dayIndex}.descriptions.${descIndex}.images`);
  };

  return (
    <div className="mt-3">
      <Form.Label className="fw-semibold">
        Descriptions{" "}
        <span className="text-muted small">(one editor + images per block)</span>
      </Form.Label>

      {descFields.map((descVariant, descIndex) => (
        <div
          key={descVariant.id}
          style={{
            border: "1px solid #dee2e6",
            borderRadius: 8,
            padding: "12px 14px",
            marginBottom: 12,
            background: "#fafbfc",
          }}
        >
          {/* ── Block header ── */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small fw-semibold">
              Description {descIndex + 1}
            </span>
            {descFields.length > 1 && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger py-0 px-2"
                style={{ fontSize: 12 }}
                onClick={() => removeDesc(descIndex)}
              >
                ✕ Remove
              </button>
            )}
          </div>

          {/* ── JoditEditor ── */}
          <Form.Group>
            <Controller
              name={`packages_detail.${dayIndex}.descriptions.${descIndex}.content`}
              control={control}
              rules={{ required: "Description is required" }}
              render={({ field }) => (
                <JoditEditor
                  value={field.value || ""}
                  onBlur={(newContent) => {
                    setValue(
                      `packages_detail.${dayIndex}.descriptions.${descIndex}.content`,
                      newContent
                    );
                    trigger(
                      `packages_detail.${dayIndex}.descriptions.${descIndex}.content`
                    );
                  }}
                />
              )}
            />
          </Form.Group>

          {errors?.packages_detail?.[dayIndex]?.descriptions?.[descIndex]?.content && (
            <span className="text-danger small d-block mt-1">
              {errors.packages_detail[dayIndex].descriptions[descIndex].content.message}
            </span>
          )}

          {/* ── Images per description ── */}
          <div className="mt-3">
            <Form.Label className="fw-semibold small">
              Images for this description block
            </Form.Label>

            {/* Hidden file input */}
            <input
              type="file"
              accept="image/*"
              multiple
              style={{ display: "none" }}
              ref={(el) => (descFileRefs.current[descIndex] = el)}
              onChange={(e) => handleDescImageAdd(descIndex, e)}
            />

            <div className="mb-2">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => descFileRefs.current[descIndex]?.click()}
              >
                + Add Images
              </button>
            </div>

            <Controller
              name={`packages_detail.${dayIndex}.descriptions.${descIndex}.images`}
              control={control}
              defaultValue={[]}
              render={({ field }) => (
                <>
                  {field.value && field.value.length > 0 ? (
                    <Row className="g-2 mt-1">
                      {field.value.map((img, imgIndex) => (
                        <Col
                          key={imgIndex}
                          xs={6}
                          sm={4}
                          md={3}
                          lg={2}
                          className="position-relative"
                        >
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              paddingTop: "100%",
                              borderRadius: 8,
                              overflow: "hidden",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <img
                              // ✅ FIX: blob preview stays as-is; saved string gets IMG_URL prefix
                              src={
                                img?.preview
                                  ? img.preview
                                  : typeof img === "string"
                                    ? IMG_URL + img
                                    : ""
                              }
                              alt={`day-${dayIndex + 1}-desc-${descIndex + 1}-img-${imgIndex + 1}`}
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => handleDescImageRemove(descIndex, imgIndex)}
                              style={{
                                position: "absolute",
                                top: 4,
                                right: 4,
                                background: "rgba(220,53,69,0.85)",
                                border: "none",
                                borderRadius: "50%",
                                width: 22,
                                height: 22,
                                color: "#fff",
                                fontSize: 12,
                                lineHeight: "22px",
                                textAlign: "center",
                                cursor: "pointer",
                                padding: 0,
                              }}
                            >
                              ✕
                            </button>
                          </div>
                          <p
                            className="text-muted text-center mt-1"
                            style={{ fontSize: 10, wordBreak: "break-all" }}
                          >
                            {img?.file?.name ?? `Image ${imgIndex + 1}`}
                          </p>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <p className="text-muted small mt-1">No images added yet.</p>
                  )}
                </>
              )}
            />

            {errors?.packages_detail?.[dayIndex]?.descriptions?.[descIndex]?.images && (
              <span className="text-danger small d-block mt-1">
                {errors.packages_detail[dayIndex].descriptions[descIndex].images.message}
              </span>
            )}
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-outline-secondary btn-sm mt-1"
        onClick={() => appendDesc(emptyDescription())}
      >
        + Add Description
      </button>
    </div>
  );
}

// ── Main Component ─────────────────────────────────────────────────────────────
const EditOffCanvance = (props) => {
  const {
    postData,
    getData,
    Select2Data,
    IMG_URL,
    getDimension,
    isAllow,
    usertype,
  } = useContext(Context);

  const id = props.show;
  const [data, setData] = useState();
  const [detailType, setDetailType] = useState([]);
  const [quantityError, setQuantityError] = useState("");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      packages_detail: [emptyDay()],
    },
  });

  const imageFile = watch("image");
  const descriptionValue = watch("description");

  // ✅ FIX: useFieldArray name matches the form field name used in rendering
  const {
    fields: detailFields,
    append: appendDetail,
    remove: removeDetail,
  } = useFieldArray({
    control,
    name: "packages_detail",
  });

  // ── Register description with validation ──────────────────────────────────
  useEffect(() => {
    register("description", { required: "Description is required." });
  }, [register]);

  // ── Fetch edit data ───────────────────────────────────────────────────────
  const GetEditData = async () => {
    const response = await getData(`/packages/${id}`);
    setData(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  // ── Fetch detail types ────────────────────────────────────────────────────
  const getDetailTypes = async () => {
    const res = await getallPackageDetailType();
    if (res?.success) {
      setDetailType(await Select2Data(res?.data, "detail_type_id"));
    } else {
      console.error("Error fetching data:", res?.error);
    }
  };

  useEffect(() => {
    getDetailTypes();
  }, [props]);

  // ── Filter already-selected options ──────────────────────────────────────
  const getFilteredOptions = (currentIndex) => {
    const allDetails = getValues("packages_detail") ?? [];
    const selectedValues = allDetails
      .map((item, i) => (i !== currentIndex ? item?.detail_type_id?.value : null))
      .filter(Boolean);
    return detailType?.filter((option) => !selectedValues.includes(option.value));
  };

  const buildFormData = (data) => {
    const formData = new FormData();

    // 🔹 Basic fields
    formData.append("name", data.name);
    formData.append("subname", data.subname);
    formData.append("description", data.description);
    formData.append("location", data.location);
    formData.append("days", data.days);
    formData.append("per_car_price", data.per_car_price);

    // 🔹 Main Image
    if (data.image && data.image[0]) {
      formData.append("image", data.image[0]);
    }

    // 🔥 Prepare CLEAN JSON (remove file objects)
    const cleanedPackages = data.packages_detail.map((pkg) => ({
      id: pkg.id || "",
      detail_type_id: pkg.detail_type_id?.value,
      descriptions: pkg.descriptions.map((desc) => ({
        id: desc.id,
        content: desc.content,
        images: desc.images.map((img) => img),
      })),
    }));

    // ✅ Send JSON
    formData.append("packages_detail", JSON.stringify(cleanedPackages));

    // 🔥 Send files separately
    data.packages_detail.forEach((pkg, i) => {
      pkg.descriptions.forEach((desc, j) => {
        desc.images.forEach((img, k) => {
          if (img.file) {
            const originalName = img.file.name;
            const ext = originalName.split('.').pop(); // png

            const fileName = `pkg_${i}_desc_${j}_${k}.${ext}`;

            formData.append("files", img.file, fileName);
          }
        });
      });
    });

    return formData;
  };

  // ── Submit ────────────────────────────────────────────────────────────────
  const onSubmit = async (data) => {
    // console.log(data, "data");
    try {
      const formData = await buildFormData(data);

      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("subname", data?.subname);
      DataToSend.append("location", data?.location);
      DataToSend.append("days", data?.days);
      DataToSend.append("per_car_price", data?.per_car_price);
      DataToSend.append("exclusion", data?.exclusion);
      DataToSend.append("inclusion", data?.inclusion);
      DataToSend.append("description", data?.description);
      DataToSend.append("note_and_disclaimers", data?.note_and_disclaimers);

      if (data?.image && data.image.length > 0) {
        DataToSend.append("image", data.image[0]);
      }

      // ✅ FIX: use packages_detail (matches useFieldArray + form fields)
      const project = [];
      data.packages_detail.forEach((detail) => {
        project.push({
          id: detail.id,
          detail_type_id: detail.detail_type_id?.value ?? detail.detail_type_id,
          descriptions: detail.descriptions,
        });
      });
      DataToSend.append("packages_detail", JSON.stringify(project));

      const response = await postData(`/packages/${id}`, formData);

      if (response?.success) {
        await props.setShowModal({ code: response.code, message: response.message });
        props.handleClose();
      } else {
        await props.setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        props.setShowModal({ code: 0, message: response.message });
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  };




  return (
    <div className="prodcuttttt">
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
        className="prodcuttttt-offcanvas"
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 rounded card">
            <Card.Body>
              <Card.Title>Edit Package</Card.Title>
              <Container>
                <Form role="form">
                  <Row>
                    {/* ── Package Name ── */}
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Package Name</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                                type="text"
                                placeholder="Package Name."
                                className={classNames("", { "is-invalid": errors?.name })}
                                {...register("name", {
                                  required: "Package Name is required",
                                  validate: (v) =>
                                    v.length <= 200 || "Data must be 200 characters or less",
                                })}
                              />
                            </InputGroup>
                            {errors.name && (
                              <span className="text-danger">{errors.name.message}</span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    {/* ── Package Sub Name ── */}
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Package Sub Name</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                                type="text"
                                placeholder="Package subname."
                                className={classNames("", { "is-invalid": errors?.subname })}
                                {...register("subname", {
                                  required: "Package subname is required",
                                  validate: (v) =>
                                    v.length <= 200 || "Data must be 200 characters or less",
                                })}
                              />
                            </InputGroup>
                            {errors.subname && (
                              <span className="text-danger">{errors.subname.message}</span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    {/* ── Location ── */}
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Location</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                                type="text"
                                placeholder="location."
                                className={classNames("", { "is-invalid": errors?.location })}
                                {...register("location", {
                                  required: "Location is required",
                                  validate: (v) =>
                                    v.length <= 200 || "Data must be 200 characters or less",
                                })}
                              />
                            </InputGroup>
                            {errors.location && (
                              <span className="text-danger">{errors.location.message}</span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    {/* ── Days ── */}
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Days</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                                min={1}
                                type="text"
                                placeholder="days."
                                className={classNames("", { "is-invalid": errors?.days })}
                                {...register("days", {
                                  required: "Days is required",
                                  min: { value: 1, message: "Minimum Days should be at least 1" },
                                })}
                                onKeyDown={(e) => {
                                  if (
                                    ["-", "+", "e", "E", "."].includes(e.key) ||
                                    (isNaN(Number(e.key)) &&
                                      e.key !== "Backspace" &&
                                      e.key !== "Tab")
                                  )
                                    e.preventDefault();
                                }}
                                onPaste={(e) => {
                                  if (!/^\d+$/.test(e.clipboardData.getData("text")))
                                    e.preventDefault();
                                }}
                              />
                            </InputGroup>
                            {errors.days && (
                              <span className="text-danger">{errors.days.message}</span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    {/* ── Per Car Price ── */}
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Per Car Price</Form.Label>
                          <Form.Group>
                            <InputGroup>
                              <Form.Control
                                min={1}
                                type="text"
                                placeholder="Per Car Price."
                                className={classNames("", { "is-invalid": errors?.per_car_price })}
                                {...register("per_car_price", {
                                  required: "Per Car Price is required",
                                  min: { value: 1, message: "Minimum Price should be at least 1" },
                                })}
                                onKeyDown={(e) => {
                                  if (
                                    ["-", "+", "e", "E", "."].includes(e.key) ||
                                    (isNaN(Number(e.key)) &&
                                      e.key !== "Backspace" &&
                                      e.key !== "Tab")
                                  )
                                    e.preventDefault();
                                }}
                                onPaste={(e) => {
                                  if (!/^\d+$/.test(e.clipboardData.getData("text")))
                                    e.preventDefault();
                                }}
                              />
                            </InputGroup>
                            {errors.per_car_price && (
                              <span className="text-danger">{errors.per_car_price.message}</span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    {/* ── Image Upload ── */}
                    <Col lg={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Image</Form.Label>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", { "is-invalid": errors?.image })}
                              type="file"
                              {...register("image", {
                                validate: (value) => {
                                  if (typeof value !== "string" && value?.length > 0) {
                                    const fileTypes = ["jpg", "png", "jpeg"];
                                    const fileType = value[0].name?.split(".").pop();
                                    if (!fileTypes.includes(fileType)) {
                                      return `Please upload a valid file format. (${fileTypes.join(", ")})`;
                                    }
                                  }
                                },
                              })}
                              accept=".jpg, .jpeg, .png"
                              multiple={false}
                            />
                          </Form.Group>
                          {errors.image && (
                            <span className="text-danger">{errors.image.message}</span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    {/* ── Image Preview ── */}
                    <Col lg={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Image Preview</Form.Label>
                          {typeof getValues("image") === "string" ? (
                            <div className="image-preview-container mt-3">
                              <img
                                src={IMG_URL + getValues("image")}
                                alt="Preview"
                                className="image-preview"
                              />
                            </div>
                          ) : (
                            imageFile?.length > 0 && (
                              <div className="image-preview-container mt-3">
                                <img
                                  src={URL.createObjectURL(imageFile[0])}
                                  alt="Preview"
                                  className="image-preview"
                                />
                              </div>
                            )
                          )}
                        </Row>
                      </div>
                    </Col>

                    {/* ── Description ── */}
                    <Col lg={12}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-start">
                          <Col sm={12}>
                            <Form.Label className="text-center">Description</Form.Label>
                            <Form.Group>
                              <Controller
                                name="description"
                                control={control}
                                rules={{ required: "Description is required" }}
                                render={({ field }) => (
                                  <JoditEditor
                                    value={descriptionValue || ""}
                                    onBlur={(newContent) => {
                                      setValue("description", newContent);
                                      trigger("description");
                                    }}
                                  />
                                )}
                              />
                            </Form.Group>
                            {errors.description && (
                              <span className="text-danger">{errors.description.message}</span>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </Col>

                    {/* ── Package Details Section ── */}
                    <div className="main-form-section mt-5" />
                    <Card.Title>
                      Package Details
                      {quantityError && (
                        <div className="text-danger">{quantityError}</div>
                      )}
                    </Card.Title>
                    <hr />

                    {/* ✅ FIX: detailFields from packages_detail useFieldArray */}
                    {detailFields.map((variant, index) => (
                      <div
                        key={variant.id}
                        className="main-form-section mt-3 p-3 border rounded"
                      >
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6 className="mb-0 fw-bold text-primary">Detail {index + 1}</h6>
                          {detailFields.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => removeDetail(index)}
                            >
                              Remove Detail
                            </button>
                          )}
                        </div>

                        <Row>
                          <Col md={6}>
                            <div className="main-form-section mt-3">
                              <Row className="justify-content-center">
                                <Form.Label>
                                  Package Detail Type{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Group>
                                  {/* ✅ FIX: Controller name uses indexed path, no extra register spread */}
                                  <Controller
                                    name={`packages_detail.${index}.detail_type_id`}
                                    control={control}
                                    rules={{ required: "Select Package Detail Type" }}
                                    render={({ field }) => (
                                      <Select
                                        className="text-dark"
                                        styles={{
                                          control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor:
                                              errors?.packages_detail?.[index]?.detail_type_id
                                                ? "red"
                                                : baseStyles.borderColor,
                                          }),
                                        }}
                                        {...field}
                                        options={getFilteredOptions(index)}
                                      />
                                    )}
                                  />
                                  {errors?.packages_detail?.[index]?.detail_type_id && (
                                    <span className="text-danger small">
                                      {errors.packages_detail[index].detail_type_id.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={12}>
                            {/* ✅ Pass IMG_URL as prop */}
                            <DayDescriptions
                              dayIndex={index}
                              control={control}
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              IMG_URL={IMG_URL}
                            />
                          </Col>
                        </Row>
                      </div>
                    ))}

                    <div className="main-form-section mt-3" />
                    <hr />
                    <div className="text-center">
                      <button
                        type="button"
                        className="btn btn-primary mb-3"
                        onClick={() => appendDetail(emptyDay())}
                      >
                        + Add Detail
                      </button>
                    </div>

                    <Row className="mt-5 pb-3">
                      <div className="d-flex justify-content-center">
                        <Link>
                          <CancelButton name={"cancel"} handleClose={props.handleClose} />
                        </Link>
                        <Button
                          onClick={handleSubmit(onSubmit)}
                          type="button"
                          className="btn btn-primary mb-3"
                        >
                          <FontAwesomeIcon icon="fa-solid fa-floppy-disk" className="me-2" />
                          Save
                        </Button>
                      </div>
                    </Row>
                    <hr />
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default EditOffCanvance;